import { render, staticRenderFns } from "./ProductMenuPage.vue?vue&type=template&id=056e64df&scoped=true"
import script from "./ProductMenuPage.vue?vue&type=script&lang=js"
export * from "./ProductMenuPage.vue?vue&type=script&lang=js"
import style0 from "./ProductMenuPage.vue?vue&type=style&index=0&id=056e64df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e64df",
  null
  
)

export default component.exports